export default __webpack_public_path__ + "static/media/BG-DarkBlue-0007.cb275a30.png";